var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("k-table", {
        ref: "table",
        attrs: {
          filterStatus: false,
          createButton: false,
          editButton: false,
          deleteButton: false,
          path: _vm.url,
          buttons: [
            {
              text: "",
              class: "btn-info",
              icon: "fa-edit",
              event: "editar"
            }
          ],
          columns: [
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Usuario",
              value: "nombre_usuario"
            },
            {
              display: "E-mail",
              value: "email"
            }
          ]
        },
        on: { editar: _vm.editar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "70%",
            height: "auto",
            name: "administrarUsuario",
            scrollable: ""
          }
        },
        [
          _c("usuario-empresa", {
            on: { updated: _vm.updatedUsuario },
            model: {
              value: _vm.selectedUsuario,
              callback: function($$v) {
                _vm.selectedUsuario = $$v
              },
              expression: "selectedUsuario"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Administración de asignación de usuarios")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ec89da4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec89da4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/AdministracionUsuarios.vue
// module id = 571
// module chunks = 0